import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import classnames from 'classnames'
import { Link } from 'react-router'
import { canUseDOM } from '../../lib/utils'
import useWindowScroll from '../../hooks/useWindowScroll'
import useWindowSize from '../../hooks/useWindowSize'
import MenuToggle from './MenuToggle'
import MobileMenu from './MobileMenu'
import './bottomNavigation.pcss'

const navItems = [
  { title: 'Etusivu', to: '/', icon: 'fa fa-home' },
  { title: 'Uusimmat', to: '/uusimmat', icon: 'fa fa-clock-o' },
  { title: 'Luetuimmat', to: '/luetuimmat', icon: 'fa fa-star-o' },
  { title: 'Äänestetyimmät', to: '/aanestetyimmat', icon: 'fa fa-thumbs-o-up' },
]

const BottomNavigation = ({ path, isLoginOverlayOpen, onMobileMenuOpen }) => {

  const [menuOpenPath, setMenuOpenPath] = useState(null)
  const { scrollY, direction } = useWindowScroll()
  const { width } = useWindowSize(50)

  // Toggle menu visibility on click of menu button (hamburger)
  const handleMenuClick = () => {
    setMenuOpenPath(prev => prev === path ? null : path)
    onMobileMenuOpen()
  }

  // Hide menu when clicking a link
  const handleLinkClick = () => {
    setMenuOpenPath(null)
  }

  // Hide menu on navigation change, when login overlay is opened, or window is resized to desktop width
  const isMenuRendered = menuOpenPath != null && menuOpenPath === path && !isLoginOverlayOpen && width < 645
  if (menuOpenPath != null && menuOpenPath === path && !isMenuRendered) {
    setMenuOpenPath(null)
  }

  // Hide nav on scroll down, show on scroll up. Except on DuckDuckGo, which has its own conflicting bottom navi hiding logic.
  // Navi is still always present in DOM, incuding on large screens. It is hidden via CSS when not needed.
  const isDuckDuckGo = canUseDOM && window.navigator.userAgent.includes('DuckDuckGo')
  const isNavVisible = isDuckDuckGo || direction === 'up' || scrollY < 12

  return (
    <React.Fragment>
      <nav className={ `mobile-bottom-nav-container mobile-bottom-nav-container--${isNavVisible ? 'visible' : 'hidden'}` } aria-hidden={ !isNavVisible } aria-label='Uutisivut'>
        <ul className='mobile-bottom-nav'>
          { navItems.map((page, i) => {
            const isActivePage = page.to === path
            return (
              <li key={ i } >
                <Link
                  to={ page.to }
                  className={ classnames('mobile-bottom-nav-item', {'mobile-bottom-nav-item--active': isActivePage && !isMenuRendered }) }
                  onClick={ handleLinkClick }
                  aria-current={ isActivePage ? 'page' : undefined }
                >
                  <span className={ `mobile-bottom-nav-item__icon ${ page.icon }` }></span>
                  <span className='mobile-bottom-nav-item__text'>{ page.title }</span>
                  <span className='sr-only'>{ isActivePage ? 'Nykyinen sivu' : '' }</span>
                </Link>
              </li>
            )
          }) }
          <li className='mobile-bottom-nav-item menu-toggle-container'>
            <MenuToggle
              isMobileMenuVisible={ isMenuRendered }
              onClick={ handleMenuClick }
            />
          </li>
        </ul>
      </nav>
      { isMenuRendered &&
        <MobileMenu
          path={ path }
          onLinkClick={ handleLinkClick }
          closeMenu={ handleLinkClick }
        />
      }
    </React.Fragment>
  )
}

BottomNavigation.propTypes = exact({
  path: PropTypes.string.isRequired,
  isLoginOverlayOpen: PropTypes.bool,
  onMobileMenuOpen: PropTypes.func.isRequired,
})

export default BottomNavigation
